export const LOGIN_PAGE_BROADCAST_CHANNEL_NAME = 'login-page-channel';
export const ROOT_PAGE_BROADCAST_CHANNEL_NAME = 'root-page-channel';
export const LOGIN_EMAIL_PASS_MESSAGE = 'SCV.LOGIN_EMAIL_PASS';
export const LOGIN_SSO_MESSAGE = 'SCV.LOGIN_SSO';
export const LOGIN_UNIFIED_MESSAGE = 'SCV.LOGIN_UNIFIED';
